import { HttpClient } from '@angular/common/http';
import { Injectable, signal, inject } from '@angular/core';
import { catchError, of } from 'rxjs';
import { prodAPI } from '../../../env';

export interface Exchange {
  id?: number;
  name: string;
  url: string;
  exchange_uid: string | null;
}

export interface WinnersResponse {
  page: number;
  pages: number;
  total: number;
  winners: Winner[];
}

export interface Winner {
  amount: number;
  date_won: string;
  exchange_name: string;
  is_twitch: boolean;
  is_youtube: boolean;
  username: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExchangesService {
  private exchangesSignal = signal<Exchange[]>([]);
  private winnersSignal = signal<WinnersResponse | null>(null);
  private http = inject(HttpClient);

  constructor() {
    this.loadExchanges();
    this.loadWinners();
  }

  private loadExchanges(): void {
    this.http.get<Exchange[]>(`${prodAPI}/api/winners/exchanges`).pipe(
      catchError((err) => {
        console.error('API request failed:', err);
        return of([]);
      })
    ).subscribe({
      next: (response) => {
        this.exchangesSignal.set(response || []);
      },
      error: (err) => {
        console.error('Failed to load exchanges:', err);
        this.exchangesSignal.set([]);
      }
    });
  }

loadWinners(page: number = 1, limit: number = 20): void {
  this.http.get<WinnersResponse>(`${prodAPI}/api/winners?page=${page}&limit=${limit}`).pipe(
    catchError((err) => {
      console.error('API request for winners failed:', err);
      return of({ 
        page: 1, 
        pages: 1, 
        total: 0, 
        winners: [] 
      } as WinnersResponse);
    })
  ).subscribe({
    next: (response) => {
      this.winnersSignal.set(response);
    },
    error: (err) => {
      console.error('Failed to load winners:', err);
      this.winnersSignal.set({ 
        page: 1, 
        pages: 1, 
        total: 0, 
        winners: [] 
      });
    }
  });
}

  getExchanges() {
    return this.exchangesSignal.asReadonly();
  }

  getWinners() {
    return this.winnersSignal.asReadonly();
  }

  refreshExchanges(): void {
    this.loadExchanges();
  }

  refreshWinners(): void {
    this.loadWinners();
  }
}